module.exports = __webpack_public_path__ + "media/images/result_icon_07-e3358874cfe38346dc0387a0c251be3a.png";